import React from "react";
import styled from "styled-components";
import renderIf from "render-if";

import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

const Wrapper = styled.div`
  width: 100%;
`;

const Input = styled(TextField)`
  width: 100%;
  max-width: 300px;
`;

const ResendText = styled(Typography).attrs({
  component: "a",
})`
  cursor: pointer;
  display: block;
`;

const ErrorText = styled(Typography).attrs({ color: "error" })``;

const ConfirmVerification = ({
  value,
  error,
  onChange,
  onResend,
  ...props
}) => {
  return (
    <Wrapper {...props}>
      <Input
        label="Enter Verification Code *"
        value={value}
        onChange={onChange}
        variant="outlined"
        style={{ marginTop: 20 }}
      />
      {renderIf(error)(<ErrorText>{error}</ErrorText>)}
      <ResendText
        component="a"
        variant="subtitle2"
        color="textSecondary"
        onClick={onResend}
      >
        Resend Code?
      </ResendText>
    </Wrapper>
  );
};

export default ConfirmVerification;
